import React__default, { useCallback } from 'react';
import { Text } from '@shopify/polaris';
import classNames from 'classnames';
import styles from '../../SelectionList.scss.mjs';
import { Item } from '../Item/Item.mjs';

function Section({
  items,
  title,
  onActionAnyItem,
  subtitle
}) {
  const handleAction = useCallback(onAction => {
    return event => {
      onAction(event);
      if (onActionAnyItem) {
        onActionAnyItem(event);
      }
    };
  }, [onActionAnyItem]);
  const titleMarkup = title ? /*#__PURE__*/React__default.createElement("div", {
    className: styles.Title
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "headingSm",
    tone: "subdued",
    as: "h3"
  }, title), subtitle) : null;
  const itemsMarkup = items.length > 0 ? items.map(({
    onAction,
    ...item
  }, index) => /*#__PURE__*/React__default.createElement(Item
  // eslint-disable-next-line react/no-array-index-key
  , Object.assign({
    key: `SelectionItem-${index}`,
    onAction: handleAction(onAction)
  }, item))) : null;
  const sectionClassNames = classNames(styles.Section, {
    [styles.hasTitle]: titleMarkup
  });
  return itemsMarkup ? /*#__PURE__*/React__default.createElement("div", {
    className: sectionClassNames
  }, titleMarkup, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("ul", {
    className: styles.List
  }, itemsMarkup))) : null;
}

export { Section };
